var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1073.28 963.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-22,.cls-24,.cls-26,.cls-5{fill:#fff;}.cls-2{fill:#111;}.cls-2,.cls-26,.cls-27{opacity:0.2;}.cls-17,.cls-3{fill:#eee;}.cls-4{fill:url(#linear-gradient);}.cls-18,.cls-21,.cls-30,.cls-5,.cls-6{opacity:0.5;}.cls-12,.cls-14,.cls-7,.cls-8{fill:none;stroke-miterlimit:10;stroke-width:2px;}.cls-7{stroke:#ddd;}.cls-8{stroke:#eee;}.cls-31,.cls-9{fill:#777;}.cls-10,.cls-16,.cls-17,.cls-9{opacity:0.25;}.cls-11{opacity:0.35;}.cls-12{stroke:#000;}.cls-13{fill:#444;}.cls-14{stroke:#111;}.cls-15{fill:#222;}.cls-16,.cls-18,.cls-20{fill:#ddd;}.cls-19,.cls-28{opacity:0.3;}.cls-22{opacity:0.1;}.cls-23,.cls-24{opacity:0.15;}.cls-25{fill:#aaa;}.cls-29{fill:url(#linear-gradient-2);}.cls-30{fill:#bbb;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 272.55,
    y1: 410.26,
    x2: 1123.79,
    y2: 638.35,
    gradientTransform: "translate(-94.39 -31.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 329.35,
    y1: 191.66,
    x2: 1180.59,
    y2: 419.75,
    gradientTransform: "translate(-123.45 138.72)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "404Page_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.68,530.29h0a331.12,331.12,0,0,0-20.91,217.8h0c38.14,155.19,197.1,248.06,351,205.08l119.27-33.31a167.12,167.12,0,0,1,85.56-1.14h0a284.61,284.61,0,0,0,287.15-93l73-86.89,57.71-78.75A292.28,292.28,0,0,0,1015.07,321h0A686.89,686.89,0,0,0,816.72,130.88l-3.3-2.08A457.59,457.59,0,0,0,448.84,74.36h0a167.21,167.21,0,0,1-72.95,3.36L240.33,53.84A207.76,207.76,0,0,0,26.48,151h0A183.7,183.7,0,0,0,38.26,358.22h0A167,167,0,0,1,57.68,530.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "953.12 356.43 753.16 140.31 235.1 140.31 235.1 140.31 174.66 140.31 150.48 152.4 150.48 159.65 150.48 159.65 150.48 215.57 126.7 221.94 106.48 239.88 108.36 246.88 150.48 404.1 150.48 870.42 150.48 870.42 150.48 877.67 150.48 877.67 276.44 877.67 285.49 911.43 285.49 911.43 285.49 911.43 411.46 877.67 928.61 878 952.79 865.91 953.12 356.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "184.33 137.9 160.15 149.98 160.15 142.73 184.33 130.64 184.33 137.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.83,134.69v1.66l-19.18,9.59v-1.67l19.18-9.58m2.5-4.05-24.18,12.09V150l24.18-12.09v-7.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "244.77 855.91 244.77 130.64 184.33 130.64 184.33 137.9 237.51 137.9 237.51 848.66 184.33 848.66 184.33 855.91 244.77 855.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242.27,133.14V853.41H186.83v-2.25H240V135.39H186.83v-2.25h55.44m2.5-2.5H184.33v7.25h53.18V848.66H184.33v7.25h60.44V130.64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 244.77,
    y: 130.64,
    width: 718.02,
    height: 725.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M252,137.89H955.53V848.66H252V137.89m-7.25-7.25V855.91h718V130.64Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.77,133.64h712V852.91h-712V133.64m-3-3V855.91h718V130.64Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "160.15 868 938.61 868 962.79 855.91 184.33 855.91 160.15 868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M200.28,855.91,176.11,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M219.62,855.91,195.45,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M239,855.91,214.79,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M258.3,855.91,234.13,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M277.64,855.91,253.47,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M297,855.91,272.81,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M316.33,855.91,292.15,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M335.67,855.91,311.49,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M355,855.91,330.83,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M374.35,855.91,350.17,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M393.69,855.91,369.51,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M413,855.91,388.85,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M432.37,855.91,408.19,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M451.71,855.91,427.53,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M471.05,855.91,446.88,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M490.39,855.91,466.22,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M509.73,855.91,485.56,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M529.07,855.91,504.9,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M548.41,855.91,524.24,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M567.76,855.91,543.58,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M587.1,855.91,562.92,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M606.44,855.91,582.26,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M625.78,855.91,601.6,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M645.12,855.91,620.94,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M664.46,855.91,640.28,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M683.8,855.91,659.62,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M703.14,855.91,679,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M722.48,855.91,698.31,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M741.82,855.91,717.65,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M761.16,855.91,737,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M780.5,855.91,756.33,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M799.84,855.91,775.67,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M819.18,855.91,795,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M838.53,855.91,814.35,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M857.87,855.91,833.69,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M877.21,855.91,853,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M896.55,855.91,872.37,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M915.89,855.91,891.71,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M935.23,855.91,911.05,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M954.57,855.91,930.39,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M196.41,855.91,172.24,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M215.75,855.91,191.58,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M235.09,855.91,210.92,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M254.43,855.91,230.26,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M273.78,855.91,249.6,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M293.12,855.91,268.94,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M312.46,855.91,288.28,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M331.8,855.91,307.62,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M351.14,855.91,327,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M370.48,855.91,346.3,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M389.82,855.91,365.64,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M409.16,855.91,385,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M428.5,855.91,404.33,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M447.84,855.91,423.67,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M467.18,855.91,443,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M486.52,855.91,462.35,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M505.86,855.91,481.69,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M525.21,855.91,501,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M544.55,855.91,520.37,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M563.89,855.91,539.71,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M583.23,855.91,559.05,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M602.57,855.91,578.39,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M621.91,855.91,597.73,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M641.25,855.91,617.07,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M660.59,855.91,636.42,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M679.93,855.91,655.76,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M699.27,855.91,675.1,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M718.61,855.91,694.44,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M738,855.91,713.78,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M757.29,855.91,733.12,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M776.64,855.91,752.46,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M796,855.91,771.8,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M815.32,855.91,791.14,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M834.66,855.91,810.48,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M854,855.91,829.82,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M873.34,855.91,849.16,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M892.68,855.91,868.5,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M912,855.91,887.84,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M931.36,855.91,907.19,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M950.7,855.91,926.53,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M950.5,858.82l-12.57,6.28H172.44L185,858.82H950.5m12.29-2.91H184.33L160.15,868H938.61l24.18-12.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "184.33 855.91 160.15 868 160.15 860.75 184.33 848.66 184.33 855.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.83,852.71v1.66L162.65,864v-1.67l19.18-9.58m2.5-4.05-24.18,12.09V868l24.18-12.09v-7.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M328,130.9a20.8,20.8,0,1,0,41.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M796.39,130.9a20.8,20.8,0,1,0,41.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M838,855.91a20.8,20.8,0,0,0-41.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M369.56,855.91a20.8,20.8,0,0,0-41.6,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "244.77 130.64 244.77 142.59 938.22 142.73 938.22 855.91 963.18 855.91 963.18 130.64 244.77 130.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 244.77,
    y1: 130.64,
    x2: 244.77,
    y2: 855.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 184.33,
    y: 137.89,
    width: 53.19,
    height: 710.77
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 232.68,
    y1: 137.89,
    x2: 232.68,
    y2: 848.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 227.84,
    y1: 137.89,
    x2: 227.84,
    y2: 848.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 223.01,
    y1: 137.89,
    x2: 223.01,
    y2: 848.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 218.17,
    y1: 137.89,
    x2: 218.17,
    y2: 848.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 213.34,
    y1: 137.89,
    x2: 213.34,
    y2: 848.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 208.5,
    y1: 137.89,
    x2: 208.5,
    y2: 848.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 203.67,
    y1: 137.89,
    x2: 203.67,
    y2: 848.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 198.83,
    y1: 137.89,
    x2: 198.83,
    y2: 848.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 194,
    y1: 137.89,
    x2: 194,
    y2: 848.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 189.16,
    y1: 137.89,
    x2: 189.16,
    y2: 848.66
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "184.33 848.66 160.15 860.75 160.15 149.98 184.33 137.9 184.33 848.66"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 179.49,
    y1: 140.31,
    x2: 179.49,
    y2: 851.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 174.66,
    y1: 142.73,
    x2: 174.66,
    y2: 853.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 169.82,
    y1: 145.15,
    x2: 169.82,
    y2: 855.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 164.99,
    y1: 147.57,
    x2: 164.99,
    y2: 858.06
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M181.43,142.59V846.87l-18.38,9.19V151.78l18.38-9.19m2.9-4.7L160.15,150V860.75l24.18-12.09V137.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M234.61,140.8v705H187.23v-705h47.38m2.9-2.91H184.33V848.66h53.18V137.89Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 160.15,
    y1: 149.98,
    x2: 184.33,
    y2: 137.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 184.33,
    y1: 848.66,
    x2: 160.15,
    y2: 860.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598,524.63H593a2.08,2.08,0,0,0-2,1.49l-8.38,28.38a62.55,62.55,0,0,0,25.66,0L600,526.12A2.08,2.08,0,0,0,598,524.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.3,519.18,609,521.64a2.09,2.09,0,0,0-1,2.28L615,552.69a62.45,62.45,0,0,0,22.23-12.83l-21.45-20.39A2.09,2.09,0,0,0,613.3,519.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.86,506.79,621.4,511a2.09,2.09,0,0,0,.3,2.48L642.08,535a62.68,62.68,0,0,0,12.84-22.23l-28.77-6.93A2.07,2.07,0,0,0,623.86,506.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.81,490.78v4.91a2.1,2.1,0,0,0,1.49,2l28.38,8.38a62.6,62.6,0,0,0,0-25.67l-28.38,8.39A2.08,2.08,0,0,0,626.81,490.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.36,475.44l2.46,4.25a2.06,2.06,0,0,0,2.28,1l28.77-6.93A62.53,62.53,0,0,0,642,451.52L621.65,473A2.08,2.08,0,0,0,621.36,475.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609,464.88l4.25,2.45a2.1,2.1,0,0,0,2.48-.29l21.44-20.39a62.7,62.7,0,0,0-22.22-12.83L608,462.59A2.07,2.07,0,0,0,609,464.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593,461.93h4.91a2.1,2.1,0,0,0,2-1.49l8.38-28.39a63.06,63.06,0,0,0-25.67,0L591,460.44A2.08,2.08,0,0,0,593,461.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.62,467.38l4.25-2.46a2.07,2.07,0,0,0,1-2.29l-6.93-28.77a62.93,62.93,0,0,0-22.22,12.83l21.45,20.39A2.07,2.07,0,0,0,577.62,467.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.06,479.76l2.45-4.25a2.08,2.08,0,0,0-.29-2.47l-20.39-21.45A62.93,62.93,0,0,0,536,473.81l28.77,6.94A2.09,2.09,0,0,0,567.06,479.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.11,495.77v-4.9a2.08,2.08,0,0,0-1.49-2l-28.39-8.38a63,63,0,0,0,0,25.66l28.39-8.38A2.08,2.08,0,0,0,564.11,495.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.55,511.12l-2.45-4.26a2.1,2.1,0,0,0-2.29-1L536,512.81A62.85,62.85,0,0,0,548.87,535l20.39-21.45A2.06,2.06,0,0,0,569.55,511.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.94,521.68l-4.25-2.46a2.07,2.07,0,0,0-2.47.3L553.77,539.9a62,62,0,0,0,10.45,7.57A63.16,63.16,0,0,0,576,552.74L582.93,524A2.09,2.09,0,0,0,581.94,521.68Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "962.79 855.91 184.33 855.91 160.15 868"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 237.51,
    y1: 137.89,
    x2: 237.51,
    y2: 848.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 184.33,
    y1: 137.89,
    x2: 184.33,
    y2: 848.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M595.46,160.49c-183.8,0-332.79,149-332.79,332.79s149,332.78,332.79,332.78,332.78-149,332.78-332.78S779.25,160.49,595.46,160.49Zm0,395.19a62.4,62.4,0,1,1,62.39-62.4A62.4,62.4,0,0,1,595.46,555.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M533.06,493.28a62.18,62.18,0,0,1,18.32-44.16l-191.2-191.2a332.79,332.79,0,0,0,0,470.67L551.34,537.4A62.17,62.17,0,0,1,533.06,493.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M639.58,537.4,830.77,728.59a332.79,332.79,0,0,0,0-470.67L639.54,449.12a62.41,62.41,0,0,1,0,88.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M534.9,509.58a62.17,62.17,0,0,1,6.26-47.4L307,327A332.78,332.78,0,0,0,428.78,781.63L564,547.46A62.18,62.18,0,0,1,534.9,509.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M649.21,524.62l234.16,135.2A332.77,332.77,0,0,0,761.51,205.2L626.31,439.36a62.39,62.39,0,0,1,22.9,85.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595.46,160.49c183.79,0,332.78,149,332.78,332.79s-149,332.78-332.78,332.78-332.79-149-332.79-332.78,149-332.79,332.79-332.79m0-15a346.74,346.74,0,1,0,135.38,27.34,345.61,345.61,0,0,0-135.38-27.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M595.46,160.49c183.79,0,332.78,149,332.78,332.79s-149,332.78-332.78,332.78-332.79-149-332.79-332.78,149-332.79,332.79-332.79m0-7.5a339.33,339.33,0,1,0,132.45,26.75A338.11,338.11,0,0,0,595.46,153Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M595.46,410.08a83.2,83.2,0,1,0,83.19,83.2A83.2,83.2,0,0,0,595.46,410.08Zm0,145.6a62.4,62.4,0,1,1,62.39-62.4A62.4,62.4,0,0,1,595.46,555.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M595.46,430.88a62.4,62.4,0,1,1-62.4,62.4,62.39,62.39,0,0,1,62.4-62.4m0-8.32a70.72,70.72,0,1,0,70.71,70.72,70.79,70.79,0,0,0-70.71-70.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M595.46,160.49c-183.8,0-332.79,149-332.79,332.79s149,332.78,332.79,332.78,332.78-149,332.78-332.78S779.25,160.49,595.46,160.49Zm0,395.19a62.4,62.4,0,1,1,62.39-62.4A62.4,62.4,0,0,1,595.46,555.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M595.46,545.28a52,52,0,1,1,52-52A52,52,0,0,1,595.46,545.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M593,522.4a29.12,29.12,0,1,1,29.12-29.12A29.12,29.12,0,0,1,593,522.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M598,522.4a29.12,29.12,0,1,1,29.12-29.12A29.12,29.12,0,0,1,598,522.4Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 338.58,
    y1: 622.39,
    x2: 852.82,
    y2: 622.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 361.98,
    y1: 663.98,
    x2: 828.94,
    y2: 663.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 396.61,
    y1: 705.58,
    x2: 795.37,
    y2: 705.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 443.23,
    y1: 747.18,
    x2: 747.68,
    y2: 747.18
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 397.88,
    cy: 493.28,
    rx: 62.4,
    ry: 31.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M362.78,486.11a4.4,4.4,0,0,1-3.71,1.37H358l.49-2.71h.77a4.89,4.89,0,0,0,4.91-3.68h2.45l-4.28,24.37h-2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M369.13,496.94c0-4.52,1.19-16.37,9.5-16.37,3,0,7.4,1.12,7.4,9,0,4.53-1.19,16.38-9.5,16.38C373.51,506,369.13,504.87,369.13,496.94Zm14-7.5c0-5.93-2.95-6.35-4.46-6.35-5.71,0-6.55,10.35-6.55,14,0,6.13,3.19,6.34,4.27,6.34C382.24,503.46,383.09,493.16,383.09,489.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M388.24,496.94c0-4.52,1.19-16.37,9.5-16.37,3,0,7.4,1.12,7.4,9,0,4.53-1.19,16.38-9.5,16.38C392.62,506,388.24,504.87,388.24,496.94Zm14-7.5c0-5.93-2.95-6.35-4.46-6.35-5.71,0-6.55,10.35-6.55,14,0,6.13,3.19,6.34,4.27,6.34C401.35,503.46,402.2,493.16,402.2,489.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M409.41,488h4l.88,11.71a12.26,12.26,0,0,1,0,2.19h.08a15.39,15.39,0,0,1,.76-2.21l5-11.69h4.12l-3.07,17.43h-2.58l2-11.39c.17-1,.44-2.38.67-3.29h-.1a18.35,18.35,0,0,1-.84,2.36l-5.3,12.32h-2.58l-1-12.32c-.05-1,0-2,0-2.36h-.1c-.1.91-.34,2.33-.51,3.29l-2,11.39h-2.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M436.73,500.06c0,2.75-1.49,5.4-5.86,5.4h-6L427.9,488h5.3c1.91,0,4.61.62,4.61,3.83a4.42,4.42,0,0,1-3.58,4.64C435.38,496.77,436.73,497.48,436.73,500.06Zm-2.89-.29c0-1.92-1.13-2.21-2.63-2.21H429.1l-1,5.72h2.56C433.08,503.28,433.84,501.51,433.84,499.77Zm1-7.54c0-1.57-.88-2-2.18-2H430.4l-.93,5.28h2.26A2.93,2.93,0,0,0,434.79,492.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M749.72,513.73H747.6v4.34h-1.39V507.63h3.86c2.74,0,3.46,1.53,3.46,3.06a2.8,2.8,0,0,1-2.35,2.85l2.67,4.53h-1.57Zm-2.12-1.18h2.31c1.62,0,2.15-.82,2.15-1.86s-.54-1.88-2.15-1.88H747.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M762.55,516.89v1.18H756V507.63h6.47v1.18h-5.07v3.32h4.82v1.17h-4.82v3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M764,512.82c0-3.21,1.64-5.44,4.75-5.44A3.83,3.83,0,0,1,772.9,511l-1.43.15a2.69,2.69,0,0,0-2.78-2.62c-2,0-3.2,1.7-3.2,4.23s1.1,4.3,3.23,4.3a2.82,2.82,0,0,0,2.82-2.55l1.36.24a4,4,0,0,1-4.18,3.53C765.49,518.32,764,515.85,764,512.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M774.14,512.85c0-3.41,1.88-5.47,4.78-5.47s4.76,2.06,4.76,5.47-1.88,5.47-4.76,5.47S774.14,516.19,774.14,512.85Zm8.07,0c0-2.68-1.2-4.29-3.29-4.29s-3.31,1.61-3.31,4.29,1.22,4.29,3.31,4.29S782.21,515.51,782.21,512.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M789.32,513.73h-2.11v4.34h-1.4V507.63h3.87c2.73,0,3.45,1.53,3.45,3.06a2.8,2.8,0,0,1-2.35,2.85l2.68,4.53h-1.58Zm-2.11-1.18h2.31c1.61,0,2.14-.82,2.14-1.86s-.54-1.88-2.14-1.88h-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M795.58,507.63H799c3,0,5,2.1,5,5.2s-1.94,5.24-5,5.24h-3.4Zm3.37,9.26c2.25,0,3.53-1.82,3.53-4.06s-1.25-4-3.5-4h-2v8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M811.4,515.05h-4.27l-1.07,3h-1.44l4-10.44H810l3.95,10.44h-1.44Zm-.41-1.17-1.46-4.08a5.28,5.28,0,0,1-.25-.79h0a5.28,5.28,0,0,1-.25.79l-1.45,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M823.07,515.2c0,1.34-.81,2.87-3.46,2.87h-3.94V507.63h3.63c2.75,0,3.47,1.54,3.47,2.78a2.29,2.29,0,0,1-1.75,2.26A2.38,2.38,0,0,1,823.07,515.2Zm-6-6.39v3.35h2.23c1.8,0,2.09-.93,2.09-1.65s-.4-1.7-2.09-1.7Zm4.61,6.26c0-1-.57-1.74-2-1.74h-2.61v3.56h2.47C821.17,516.89,821.68,516,821.68,515.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M825.34,507.63h1.4v9.26h4.82v1.18h-6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M839.89,516.89v1.18h-6.57V507.63h6.47v1.18h-5.07v3.32h4.82v1.17h-4.82v3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M746.21,486.09c0-12.22,3.8-17.85,12.08-17.85,6.88,0,10.44,3.85,10.72,11.55l-4.28.43c-.24-5.58-2.4-8.37-6.54-8.37-5.68,0-7.56,4.47-7.56,14.19,0,10,2,14.29,7.66,14.29,3.94,0,6.2-2.84,6.59-8.23l4.13.68c-.57,7.36-4.28,11.26-10.77,11.26C749.53,504,746.21,498.22,746.21,486.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M775,469.06h8.8c8.76,0,13.43,5.68,13.43,16.89,0,11.5-4.91,17.27-13.57,17.27H775Zm8.56,30.79c6,0,9.19-4.67,9.19-13.9s-3.17-13.52-9.14-13.52h-4.42v27.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M813.33,488v3.65h-12V488Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M828.58,488.69h-5.19v14.53H819.2V469.06h9.72c7.51,0,10,4.09,10,9.76,0,4.38-1.88,7.9-6,9.15l7,15.25h-4.72Zm-5.19-3.27h5.24c4.19,0,5.78-2.6,5.78-6.6s-1.59-6.39-5.83-6.39h-5.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 933.67,
    y: 213.84,
    width: 8.32,
    height: 166.39,
    rx: 4.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 933.67,
    y: 606.32,
    width: 8.32,
    height: 166.39,
    rx: 4.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M184.33,855.91V130.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "962.79 855.91 962.79 130.64 184.33 130.64 160.15 142.73 160.15 868 938.61 868 962.79 855.91 962.79 855.91"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "184.33 137.9 237.51 137.9 237.51 848.66 184.33 848.66 184.33 855.91"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 256.86,
    y: 142.73,
    width: 693.84,
    height: 701.1,
    rx: 24.18
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M950.7,166.91a24.17,24.17,0,0,0-24.18-24.18H381.59L256.86,267.47V819.65A24.18,24.18,0,0,0,281,843.83h32.11L950.7,206.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "681.02 843.83 950.7 574.14 950.7 329.28 436.16 843.83 681.02 843.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "822.93 843.83 950.7 716.06 950.7 610.88 717.75 843.83 822.93 843.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "160.15 513.6 255.11 868 564.19 868 962.79 761.2 962.79 407.93 926.73 273.35 888.49 130.64 467.12 130.64 457.07 133.33 181.89 207.07 166.71 211.14 160.15 212.89 160.15 513.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "134.38 209.71 114.16 227.64 112.28 220.64 132.5 202.71 134.38 209.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.14,207.26l.43,1.61-16,14.22-.43-1.61,16-14.22m1.36-4.56-20.22,17.94,1.88,7,20.22-17.93-1.88-7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "378.6 887.62 190.88 187.06 132.5 202.71 134.38 209.71 185.75 195.94 369.71 882.49 318.34 896.26 320.22 903.26 378.6 887.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M189.12,190.12,375.54,885.85,322,900.2,321.4,898l49-13.12,2.42-.65-.65-2.41-184-686.55-.65-2.42-2.41.65-49,13.12-.58-2.18,53.55-14.35m1.76-3.06L132.5,202.7l1.88,7,51.38-13.77,184,686.55-51.38,13.77,1.88,7,58.38-15.64L190.88,187.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 272.51,
    y: 81.79,
    width: 718.02,
    height: 725.27,
    transform: "translate(-93.51 178.59) rotate(-15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M199.77,192.19,879.31,10.11l184,686.55L383.73,878.74l-184-686.55m-8.89-5.13L378.6,887.62l693.55-185.84L884.44,1.22,190.88,187.06Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M882.32,4.9l186.16,694.76L380.72,884,194.56,189.18,882.32,4.9m2.12-3.68L190.88,187.06,378.6,887.62l693.55-185.84L884.44,1.22Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "300 921.2 1051.93 719.72 1072.15 701.78 320.22 903.26 300 921.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M335.63,899.14,315.4,917.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M354.31,894.13l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M373,889.12l-20.22,17.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M391.67,884.12l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M410.35,879.11l-20.22,17.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M429,874.11,408.81,892"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M447.72,869.1,427.49,887"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M466.4,864.1,446.18,882"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M485.08,859.09,464.86,877"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M503.76,854.08,483.54,872"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M522.44,849.08,502.22,867"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M541.13,844.07,520.9,862"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M559.81,839.07,539.58,857"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M578.49,834.06,558.27,852"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M597.17,829.05,577,847"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M615.85,824.05,595.63,842"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M634.54,819,614.31,837"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M653.22,814,633,832"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M671.9,809,651.68,827"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M690.58,804,670.36,822"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M709.26,799,689,817"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M727.94,794,707.72,812"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M746.63,789,726.4,806.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M765.31,784l-20.23,17.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M784,779l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M802.67,774l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M821.35,769l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M840,764l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M858.72,759l-20.23,17.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M877.4,754,857.17,771.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M896.08,749,875.86,766.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M914.76,744l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M933.44,739l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M952.12,734,931.9,751.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M970.81,728.94l-20.23,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M989.49,723.93l-20.23,17.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1008.17,718.93,988,736.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1026.85,713.92l-20.22,17.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1045.53,708.92l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1064.22,703.91,1044,721.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M331.89,900.14l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M350.57,895.13l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M369.25,890.12,349,908.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M387.94,885.12l-20.23,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M406.62,880.11l-20.23,17.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M425.3,875.11,405.08,893"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M444,870.1,423.76,888"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M462.66,865.1,442.44,883"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M481.35,860.09,461.12,878"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M500,855.08,479.8,873"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M518.71,850.08,498.49,868"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M537.39,845.07,517.17,863"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M556.07,840.07,535.85,858"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M574.75,835.06,554.53,853"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M593.44,830.06,573.21,848"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M612.12,825.05,591.89,843"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M630.8,820,610.58,838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M649.48,815,629.26,833"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M668.16,810,647.94,828"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M686.84,805,666.62,823"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M705.53,800,685.3,818"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M724.21,795,704,813"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M742.89,790l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M761.57,785l-20.22,17.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M780.25,780,760,797.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M798.93,775l-20.22,17.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M817.62,770l-20.23,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M836.3,765l-20.23,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M855,760l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M873.66,755,853.44,772.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M892.34,750,872.12,767.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M911,745,890.8,762.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M929.71,740l-20.23,17.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M948.39,735l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M967.07,729.94l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M985.75,724.94l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1004.43,719.93l-20.22,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1023.12,714.92l-20.23,17.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1041.8,709.92l-20.23,17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1060.48,704.91l-20.22,17.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1061,707.77l-10.51,9.32L311.11,915.21l10.52-9.32L1061,707.77m11.12-6L320.22,903.26,300,921.2l751.94-201.48,20.22-17.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "320.22 903.26 300 921.2 298.12 914.19 318.34 896.26 320.22 903.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317,900.81l.43,1.61-16,14.22-.43-1.6,16-14.23m1.37-4.55-20.22,17.93,1.87,7,20.23-17.94-1.88-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M271.31,165.78A20.8,20.8,0,1,0,311.49,155Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M723.78,44.54A20.8,20.8,0,1,0,764,33.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M951.61,734.08a20.8,20.8,0,0,0-40.18,10.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M499.14,855.32A20.8,20.8,0,1,0,459,866.09Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "190.88 187.06 193.98 198.6 863.84 19.26 1048.42 708.14 1072.53 701.68 884.82 1.12 190.88 187.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 190.88,
    y1: 187.06,
    x2: 378.6,
    y2: 887.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 225.45,
    y: 190.72,
    width: 53.19,
    height: 710.77,
    transform: "translate(-132.75 83.84) rotate(-15)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 181.09,
    y1: 197.2,
    x2: 365.05,
    y2: 883.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 176.41,
    y1: 198.45,
    x2: 360.37,
    y2: 885
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 171.74,
    y1: 199.7,
    x2: 355.7,
    y2: 886.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 167.07,
    y1: 200.95,
    x2: 351.03,
    y2: 887.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 162.4,
    y1: 202.2,
    x2: 346.36,
    y2: 888.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 157.73,
    y1: 203.45,
    x2: 341.69,
    y2: 890
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 153.06,
    y1: 204.7,
    x2: 337.02,
    y2: 891.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 148.39,
    y1: 205.96,
    x2: 332.35,
    y2: 892.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 143.72,
    y1: 207.21,
    x2: 327.68,
    y2: 893.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 139.05,
    y1: 208.46,
    x2: 323.01,
    y2: 895.01
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "318.34 896.26 298.12 914.19 114.16 227.64 134.38 209.71 318.34 896.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 130.34,
    y1: 213.3,
    x2: 314.3,
    y2: 899.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 126.29,
    y1: 216.88,
    x2: 310.25,
    y2: 903.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 122.25,
    y1: 220.47,
    x2: 306.21,
    y2: 907.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 118.2,
    y1: 224.06,
    x2: 302.09,
    y2: 910.34
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M132.79,215,315.07,895.28,299.7,908.91,117.42,228.62,132.79,215m1.59-5.29-20.22,17.93,184,686.55,20.22-17.93-184-686.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M183.7,199.5,366.16,880.44l-45.77,12.27L137.93,211.76,183.7,199.5m2.06-3.56-51.38,13.77,184,686.55,51.38-13.77-184-686.55Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 114.16,
    y1: 227.64,
    x2: 134.38,
    y2: 209.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 318.34,
    y1: 896.26,
    x2: 298.12,
    y2: 914.19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634,476.21l-4.74,1.27a2.1,2.1,0,0,0-1.55,2L627,509a62.77,62.77,0,0,0,24.79-6.64l-15.44-25.24A2.07,2.07,0,0,0,634,476.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.42,467l-3.48,3.47a2.09,2.09,0,0,0-.35,2.47l14.14,26a62.75,62.75,0,0,0,18.15-18.14l-26-14.15A2.08,2.08,0,0,0,647.42,467Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.41,452.28,653.14,457a2.08,2.08,0,0,0,.92,2.31l25.25,15.45a62.93,62.93,0,0,0,4.6-12A62.24,62.24,0,0,0,686,450l-29.58.75A2.08,2.08,0,0,0,654.41,452.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.12,436.05l1.27,4.74a2.07,2.07,0,0,0,2,1.54l29.58.75a62.78,62.78,0,0,0-6.64-24.78L654,433.74A2.08,2.08,0,0,0,653.12,436.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.89,422.64l3.47,3.47a2.06,2.06,0,0,0,2.46.36l26-14.14a62.94,62.94,0,0,0-18.15-18.15l-14.14,26A2.06,2.06,0,0,0,643.89,422.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.18,415.65l4.75,1.27a2.07,2.07,0,0,0,2.31-.93l15.44-25.24a62.77,62.77,0,0,0-24.79-6.64l.75,29.58A2.09,2.09,0,0,0,629.18,415.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613,416.94l4.74-1.27a2.08,2.08,0,0,0,1.54-2l.75-29.58a62.77,62.77,0,0,0-24.79,6.64L610.64,416A2.09,2.09,0,0,0,613,416.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.55,426.17,603,422.7a2.08,2.08,0,0,0,.36-2.46l-14.15-26a62.75,62.75,0,0,0-18.14,18.15l26,14.14A2.09,2.09,0,0,0,599.55,426.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.55,440.87l1.27-4.74a2.07,2.07,0,0,0-.92-2.31l-25.25-15.44A62.77,62.77,0,0,0,561,443.17l29.59-.76A2.07,2.07,0,0,0,592.55,440.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.84,457.1l-1.27-4.74a2.06,2.06,0,0,0-2-1.54L561,450.07a63.64,63.64,0,0,0,2,12.74,62.71,62.71,0,0,0,4.61,12.05l25.24-15.45A2.07,2.07,0,0,0,593.84,457.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.08,470.51,599.61,467a2.09,2.09,0,0,0-2.47-.36l-26,14.14a61.93,61.93,0,0,0,8.13,10,62.84,62.84,0,0,0,10,8.13l14.14-26A2.09,2.09,0,0,0,603.08,470.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.78,477.51,613,476.24a2.09,2.09,0,0,0-2.32.92L595.28,502.4A62.71,62.71,0,0,0,607.33,507a63.64,63.64,0,0,0,12.74,2l-.75-29.59A2.06,2.06,0,0,0,617.78,477.51Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "1072.15 701.78 320.22 903.26 300 921.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 185.76,
    y1: 195.94,
    x2: 369.72,
    y2: 882.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 134.38,
    y1: 209.71,
    x2: 318.34,
    y2: 896.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M537.35,125.13C359.82,172.7,254.47,355.18,302,532.71S532.08,815.59,709.61,768,992.5,538,944.93,360.45,714.88,77.56,537.35,125.13ZM639.63,506.85a62.4,62.4,0,1,1,44.12-76.42A62.4,62.4,0,0,1,639.63,506.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M563.21,462.73a62.21,62.21,0,0,1,6.27-47.4L335.31,280.13A332.8,332.8,0,0,0,457.09,734.78L592.28,500.61A62.18,62.18,0,0,1,563.21,462.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M677.52,477.77,911.68,613A332.77,332.77,0,0,0,789.82,158.35L654.63,392.51a62.4,62.4,0,0,1,22.89,85.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M569.2,478a62.18,62.18,0,0,1-6.21-47.4l-261.18-70a332.78,332.78,0,0,0,235.3,407.63l70-261.18A62.22,62.22,0,0,1,569.2,478Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M683.51,462.94l261.18,70a332.8,332.8,0,0,0-235.38-407.6l-70,261.18a62.39,62.39,0,0,1,44.18,76.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M623.69,113.71c146.93,0,281.4,98.06,321.24,246.73C992.5,538,887.14,720.45,709.61,768a333.19,333.19,0,0,1-86.34,11.42c-146.92,0-281.4-98.06-321.23-246.73-47.57-177.53,57.78-360,235.31-407.58a333.24,333.24,0,0,1,86.34-11.42m0-15a348.09,348.09,0,1,0,111.4,18.44,348.63,348.63,0,0,0-111.4-18.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M623.69,113.71c146.93,0,281.4,98.06,321.24,246.73C992.5,538,887.14,720.45,709.61,768a333.19,333.19,0,0,1-86.34,11.42c-146.92,0-281.4-98.06-321.23-246.73-47.57-177.53,57.78-360,235.31-407.58a333.24,333.24,0,0,1,86.34-11.42m0-7.5a340.53,340.53,0,1,0,109,18,341.2,341.2,0,0,0-109-18Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M602,366.21A83.2,83.2,0,1,0,703.84,425,83.21,83.21,0,0,0,602,366.21Zm37.68,140.64a62.4,62.4,0,1,1,44.12-76.42A62.4,62.4,0,0,1,639.63,506.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M607.33,386.31a62.4,62.4,0,1,1-44.12,76.42,62.39,62.39,0,0,1,44.12-76.42m-2.15-8a70.71,70.71,0,1,0,86.61,50,70.79,70.79,0,0,0-86.61-50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M537.35,125.13C359.82,172.7,254.47,355.18,302,532.71S532.08,815.59,709.61,768,992.5,538,944.93,360.45,714.88,77.56,537.35,125.13ZM639.63,506.85a62.4,62.4,0,1,1,44.12-76.42A62.4,62.4,0,0,1,639.63,506.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M636.94,496.8a52,52,0,1,1,36.77-63.68A52,52,0,0,1,636.94,496.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M628.61,475.35a29.12,29.12,0,1,1,20.59-35.66A29.13,29.13,0,0,1,628.61,475.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M633.43,474.06A29.12,29.12,0,1,1,654,438.39,29.12,29.12,0,0,1,633.43,474.06Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 408.78,
    y1: 637.77,
    x2: 905.49,
    y2: 504.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 442.14,
    y1: 671.89,
    x2: 893.19,
    y2: 551.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 486.35,
    y1: 703.11,
    x2: 871.54,
    y2: 599.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-12",
    x1: 542.16,
    y1: 731.23,
    x2: 836.24,
    y2: 652.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 432.64,
    cy: 497.71,
    rx: 62.4,
    ry: 31.2,
    transform: "translate(-114.08 128.93) rotate(-15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M396.88,499.87a4.39,4.39,0,0,1-3.24,2.28l-1.08.29-.22-2.73.74-.2a4.9,4.9,0,0,0,3.79-4.83l2.37-.63,2.18,24.64-2.82.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M405.82,508.69c-1.18-4.37-3.09-16.12,4.94-18.27,2.91-.78,7.43-.83,9.48,6.82,1.17,4.37,3.09,16.13-4.94,18.28C412.39,516.3,407.87,516.35,405.82,508.69Zm11.53-10.86c-1.53-5.72-4.48-5.36-5.94-5-5.52,1.47-3.66,11.68-2.7,15.24,1.58,5.93,4.72,5.3,5.77,5C420.17,511.6,418.31,501.42,417.35,497.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M424.27,503.75c-1.17-4.37-3.08-16.13,4.94-18.28,2.92-.78,7.44-.83,9.49,6.82,1.17,4.37,3.09,16.13-4.94,18.28C430.85,511.35,426.33,511.4,424.27,503.75Zm11.54-10.86c-1.53-5.73-4.49-5.37-5.94-5-5.52,1.48-3.66,11.69-2.71,15.24,1.59,5.93,4.73,5.31,5.78,5C438.63,506.65,436.77,496.48,435.81,492.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M442.42,489.66l3.89-1,3.88,11.08a13,13,0,0,1,.57,2.11l.07,0a16.15,16.15,0,0,1,.16-2.33l1.82-12.58,4-1.07,1.55,17.63-2.49.67-1-11.52c-.08-1-.19-2.41-.21-3.35l-.1,0a20.24,20.24,0,0,1-.19,2.49L452.38,505l-2.49.66-4.13-11.65a22.48,22.48,0,0,1-.61-2.27l-.1,0c.14.91.27,2.34.36,3.31l1,11.53-2.44.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M471.92,494.21c.71,2.66-.05,5.6-4.27,6.73l-5.83,1.57-1.55-17.63,5.12-1.37c1.85-.5,4.62-.61,5.45,2.5a4.43,4.43,0,0,1-2.26,5.41C469.77,491.38,471.25,491.72,471.92,494.21Zm-2.87.47c-.5-1.86-1.66-1.85-3.11-1.46l-2,.55.51,5.78,2.46-.66C469.22,498.26,469.5,496.36,469.05,494.68Zm-1-7.53c-.4-1.52-1.38-1.74-2.64-1.41l-2.13.58.46,5.34,2.19-.59A2.93,2.93,0,0,0,468,487.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.88,273q4.18-1.12,11.25,4.46t8.33,10.24a2,2,0,0,1-1.38,2.74,328.52,328.52,0,0,0-31.92,16.64q2.13,35.46,6.25,50.87.69,2.55-3.17,3.58-6.39,1.71-16.16-.15T485,354.59a4.45,4.45,0,0,1,.79-3.28q-1.61-10.56-2.92-27.61a278.1,278.1,0,0,0-28.62,22.08A9.65,9.65,0,0,1,450.7,348q-4.68,1.26-13.44-2.76t-9.67-7.39q-1.15-4.33,3.44-50.61T440.94,223c.23-.88,1.14-1.54,2.72-2q5-1.34,13.68,1.52t9.62,6.38a3.44,3.44,0,0,1-.08,1.69q-2.53,7.89-6.22,36.78t-4.22,46.25q8.24-6.33,24.85-17.12-1.43-38.8.16-65.33a3.38,3.38,0,0,1,2.72-3.28q5.41-1.44,14,.86t9.6,6a5.54,5.54,0,0,1,0,1.4q-.79,13.14,0,44.45Q520.33,273.69,522.88,273Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.15,195.16q19.27,9.59,27.64,40.48a123.17,123.17,0,0,1,4,29.87,142.09,142.09,0,0,1-2.78,31,69.54,69.54,0,0,1-10.91,26.17q-7.87,11.3-19.43,14.39-20.18,5.4-34.28-6.59t-20.41-35.52a141.58,141.58,0,0,1-4.67-42q.76-21.69,8.6-38.38t21.61-20.37a14.66,14.66,0,0,1,11,1.36Q579,192,585.15,195.16ZM572.4,318.08q11.22-11.26,14.38-33.73a107.26,107.26,0,0,0-2.37-43.13q-5.13-19.09-15.7-28.39-11.13,10.89-14,32.49a105.38,105.38,0,0,0,2.47,41.52Q562.45,306.51,572.4,318.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.48,220.05q4.18-1.11,11.25,4.46t8.33,10.24a2,2,0,0,1-1.38,2.74,328.52,328.52,0,0,0-31.92,16.64Q708.89,289.59,713,305q.69,2.53-3.17,3.57-6.39,1.71-16.16-.15t-11.09-6.78a4.46,4.46,0,0,1,.79-3.29q-1.61-10.56-2.92-27.6a276.82,276.82,0,0,0-28.61,22.08A10,10,0,0,1,648.3,295q-4.68,1.25-13.44-2.77t-9.67-7.38q-1.16-4.35,3.44-50.62T638.54,170c.23-.88,1.14-1.53,2.72-2q5-1.34,13.68,1.52t9.62,6.39a3.44,3.44,0,0,1-.08,1.69q-2.54,7.89-6.22,36.77T654,260.7q8.24-6.33,24.85-17.11-1.42-38.81.16-65.33a3.36,3.36,0,0,1,2.72-3.28q5.41-1.46,14,.85t9.6,6a5.51,5.51,0,0,1,0,1.4q-.79,13.13,0,44.45Q717.94,220.74,720.48,220.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.58,640.93a6.6,6.6,0,0,1-3.82-.5c-1.59-.58-2.46-1.15-2.61-1.72a1,1,0,0,1,.07-.49,1.73,1.73,0,0,0,0-.79,160.41,160.41,0,0,1-.88-36.22.88.88,0,0,1,.72-.82,9.51,9.51,0,0,1,4,.06c1.68.31,2.6.75,2.75,1.34a2.18,2.18,0,0,1,0,.73,147.33,147.33,0,0,0,0,30.15q3-2.34,7.24-5a35.36,35.36,0,0,1,5-2.92c.76-.2,1.84.26,3.23,1.39a6.68,6.68,0,0,1,2.37,2.74c.05.2,0,.34-.08.42a15.8,15.8,0,0,1-2.23,1.45,1,1,0,0,1-.7,0,71.28,71.28,0,0,0-7.12,4.39,66.36,66.36,0,0,0-6.79,5.13A3,3,0,0,1,419.58,640.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.84,629.93a11.29,11.29,0,0,1-6-.12,9,9,0,0,1-5.09-3.51,17.72,17.72,0,0,1-2.64-6A36.84,36.84,0,0,1,435.94,609a28,28,0,0,1,2.2-10.18c1.29-2.86,2.93-4.56,4.94-5.09a6.42,6.42,0,0,1,4.7.54,8.3,8.3,0,0,1,5.64,2,12.37,12.37,0,0,1,3,5.82,38.52,38.52,0,0,1,.91,12.62,37.51,37.51,0,0,1-2.12,11.14A6.5,6.5,0,0,1,450.84,629.93Zm-3.58-4.55q2-2.65,2.48-9.86a38.37,38.37,0,0,0-.95-12.69,14.34,14.34,0,0,0-1.53-3.81c-2,2-3.16,4.94-3.57,8.88a31.38,31.38,0,0,0,.88,11.49A17,17,0,0,0,447.26,625.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.74,623.26a11.32,11.32,0,0,1-6-.12,9,9,0,0,1-5.08-3.51,17.33,17.33,0,0,1-2.64-6,37.15,37.15,0,0,1-1.2-11.38A27.78,27.78,0,0,1,463,592.11c1.28-2.86,2.93-4.56,4.93-5.09a6.45,6.45,0,0,1,4.71.54,8.27,8.27,0,0,1,5.63,2,12.28,12.28,0,0,1,3,5.82,38.5,38.5,0,0,1,.92,12.62,37.46,37.46,0,0,1-2.13,11.14A6.47,6.47,0,0,1,475.74,623.26Zm-3.59-4.55q2-2.65,2.48-9.86a38.39,38.39,0,0,0-.94-12.69,14.34,14.34,0,0,0-1.53-3.81c-2,2-3.17,4.94-3.58,8.88a31.38,31.38,0,0,0,.88,11.49A17.06,17.06,0,0,0,472.15,618.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.81,607.42q1.26-.2,1.5.69.35,1.27-.87,3.57a4.83,4.83,0,0,1-2.66,2.68q-1.06.28-4.84-1.31a61.51,61.51,0,0,1-7.33-3.72c.31,3.39.72,6.47,1.25,9.23q.13.68-1.38,1.08a9.74,9.74,0,0,1-3.75.19c-1.4-.18-2.19-.59-2.37-1.26q-1.16-4.29-1.67-19.23t-.23-19.56c0-.36.38-.63,1.06-.81a9.16,9.16,0,0,1,3.9-.05c1.53.25,2.38.69,2.55,1.3a4.25,4.25,0,0,1,0,.72q-.32,10.48.07,20.08a85.34,85.34,0,0,0,3.38-9.53q1.53-5.24,2.21-8.49a36.36,36.36,0,0,0,.69-4c0-.24.24-.44.74-.59a7.47,7.47,0,0,1,3.64.22c1.51.39,2.37.95,2.57,1.68q.5,1.86-2,10.22a106,106,0,0,1-5,13.72Q505.53,607.23,507.81,607.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.66,611.78a10.82,10.82,0,0,1-5.1.11,14,14,0,0,1-4.54-1.72,22.93,22.93,0,0,1-3.13-2.32,4.86,4.86,0,0,1-1.41-1.71c-.22-.82.22-1.83,1.32-3a7.41,7.41,0,0,1,3.16-2.22,1.11,1.11,0,0,1,1.16.26,22.15,22.15,0,0,0,5,3.78q2.67,1.45,4.31,1c.09-1.13-.56-2.65-1.93-4.55a50.37,50.37,0,0,0-4.64-5.51,73.1,73.1,0,0,1-5.08-5.85,16.51,16.51,0,0,1-3.08-5.36,10.93,10.93,0,0,1-.23-5,9.25,9.25,0,0,1,1.79-4,13.14,13.14,0,0,1,3.05-2.81,12.47,12.47,0,0,1,3.7-1.69,7.49,7.49,0,0,1,5.3.39,9.31,9.31,0,0,1,3.81,3.2,15,15,0,0,1,2,4.54c.43,1.6.52,2.6.27,3-.54.93-1.93,1.69-4.17,2.3-1.5.4-2.34.29-2.5-.33,0,0,0-.14-.07-.34l-.15-.75c-.07-.3-.14-.61-.23-.92q-1.47-5.49-5.14-6.22a5.78,5.78,0,0,0-.73,5,15.87,15.87,0,0,0,2.92,5.24,57.26,57.26,0,0,0,4.8,5.52,64.12,64.12,0,0,1,4.77,5.38,14.77,14.77,0,0,1,2.84,4.95,5.34,5.34,0,0,1-.71,4.35,10.2,10.2,0,0,1-3.3,3.36A15.24,15.24,0,0,1,525.66,611.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.06,603a6.57,6.57,0,0,1-3.81-.5c-1.59-.58-2.46-1.15-2.62-1.72a1.23,1.23,0,0,1,.08-.49,1.74,1.74,0,0,0,0-.79,161.58,161.58,0,0,1-.88-36.22.9.9,0,0,1,.73-.82,9.51,9.51,0,0,1,4,.06c1.68.3,2.6.75,2.75,1.34a2.44,2.44,0,0,1,0,.72,147.32,147.32,0,0,0,0,30.15q3-2.32,7.24-5a35.36,35.36,0,0,1,5-2.92c.76-.2,1.84.26,3.23,1.38a6.69,6.69,0,0,1,2.37,2.75c0,.2,0,.34-.08.41a15.26,15.26,0,0,1-2.23,1.46,1,1,0,0,1-.7,0,71.61,71.61,0,0,0-7.12,4.38,66.56,66.56,0,0,0-6.79,5.14A3.11,3.11,0,0,1,561.06,603Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.73,561.66a9.41,9.41,0,0,1-3.51.21c-1.28-.14-2-.5-2.14-1.06a15.35,15.35,0,0,1-.23-2.55A17.83,17.83,0,0,1,579,555c0-.43.43-.74,1.16-.94a11,11,0,0,1,3.65-.21c1.45.12,2.26.47,2.42,1.06a13.26,13.26,0,0,1-.07,2.58,19.08,19.08,0,0,0-.1,3C586.11,561,585.68,561.4,584.73,561.66Zm2.5,33.63a9.67,9.67,0,0,1-3.87.16c-1.43-.21-2.23-.63-2.4-1.28A73.87,73.87,0,0,1,579.69,584q-.65-7.92-.78-17c0-.48.44-.83,1.25-1a8.93,8.93,0,0,1,3.68-.08c1.42.22,2.21.63,2.37,1.22a2.1,2.1,0,0,1,0,.37,90.35,90.35,0,0,0,.29,11.81q.56,7.14,1.22,11.54a.65.65,0,0,1,.34.4,8.29,8.29,0,0,1,.49,3.17Q588.37,595,587.23,595.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.22,579.18c.84-.14,1.34.09,1.5.68q.35,1.27-.87,3.57a4.83,4.83,0,0,1-2.66,2.68c-.71.19-2.32-.24-4.84-1.31a58.67,58.67,0,0,1-7.33-3.72c.31,3.39.72,6.47,1.25,9.23.09.46-.37.82-1.38,1.09a10,10,0,0,1-3.75.18c-1.4-.17-2.19-.59-2.37-1.25q-1.15-4.3-1.67-19.24t-.23-19.55c0-.37.38-.64,1.06-.82a9.49,9.49,0,0,1,3.9-.05c1.53.25,2.39.69,2.55,1.31a4.25,4.25,0,0,1,0,.72q-.32,10.47.08,20.08a85.39,85.39,0,0,0,3.37-9.53q1.53-5.25,2.21-8.49a36.76,36.76,0,0,0,.69-4c0-.25.24-.45.74-.6a7.47,7.47,0,0,1,3.64.22c1.51.39,2.37.95,2.57,1.69q.49,1.86-2,10.21a104.72,104.72,0,0,1-5,13.73C608.84,578,611.7,579,613.22,579.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.6,541.4c1.12-.3,2.28.17,3.49,1.39a8,8,0,0,1,2.15,3.17.56.56,0,0,1-.37.77,70.73,70.73,0,0,0-9.74,4.88q-.33,3-.48,8.14a22.05,22.05,0,0,1,3.88-2.36c.59-.16,1.6.26,3,1.25s2.22,1.82,2.39,2.47c.1.36,0,.59-.28.7a25.45,25.45,0,0,0-4.7,2.73,47.19,47.19,0,0,0-4.33,3.39,74.12,74.12,0,0,0,.57,9.05,47.89,47.89,0,0,1,4.39-4.67,17.14,17.14,0,0,1,3-2.58c.73-.2,1.81.21,3.22,1.24a6,6,0,0,1,2.44,2.68c.08.33.05.55-.11.65A69.28,69.28,0,0,0,628,585.6a1.7,1.7,0,0,1-.8.56q-1.32.36-4.08-.9c-1.83-.83-2.85-1.61-3-2.33a57.39,57.39,0,0,1-1.31-12q-.27-8.09.13-15.78a11.43,11.43,0,0,1-2.83-1.31,3.39,3.39,0,0,1-1.6-1.63.65.65,0,0,1,.19-.68,55.42,55.42,0,0,1,7-4.84,69.6,69.6,0,0,1,8.45-4.7A.69.69,0,0,1,630.6,541.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.3,533.71a7.35,7.35,0,0,1,0,1.18q0,.63-.41,6.78t-.57,9.6c-.13,2.31-.26,5.21-.4,8.72s-.18,6.36-.1,8.57a23.33,23.33,0,0,0,.49,4.72c0,.06.06.21.14.46a2.5,2.5,0,0,1,.13.48.51.51,0,0,1-.15.33,1,1,0,0,1-.55.33,8.69,8.69,0,0,1-4.69-.42c-1.91-.59-3-1.38-3.25-2.34a3.28,3.28,0,0,1,.31-2.12c-.06-2.7,0-5.28.08-7.72a9.93,9.93,0,0,1-2.72.21c-.85-.06-1.39-.25-1.61-.57a43.8,43.8,0,0,1-4-8.16q-2.16-5.5-3.24-9c-.73-2.36-1.27-4.22-1.65-5.61-.2-.76.27-1.3,1.4-1.6a9.19,9.19,0,0,1,3.8-.09c1.44.23,2.24.66,2.41,1.28a107.78,107.78,0,0,0,5.79,16.79q.39-8,1.41-21.62a6.52,6.52,0,0,0-.11-.69,2.77,2.77,0,0,1-.09-.74,1.62,1.62,0,0,1,.35-.73,1.32,1.32,0,0,1,.59-.52,7,7,0,0,1,3.8.56C674.17,532.35,675.11,533,675.3,533.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.64,564.88a11.49,11.49,0,0,1-6-.12,9,9,0,0,1-5.09-3.52,17.72,17.72,0,0,1-2.64-6,36.84,36.84,0,0,1-1.19-11.38,27.83,27.83,0,0,1,2.2-10.18q1.93-4.29,4.93-5.09a6.5,6.5,0,0,1,4.71.54,8.25,8.25,0,0,1,5.63,2,12.28,12.28,0,0,1,3,5.82,38.55,38.55,0,0,1,.91,12.62,37.58,37.58,0,0,1-2.12,11.15A6.52,6.52,0,0,1,693.64,564.88Zm-3.58-4.56q2-2.66,2.48-9.85a38.41,38.41,0,0,0-.95-12.7,14.13,14.13,0,0,0-1.53-3.8q-3,3-3.57,8.88a31.32,31.32,0,0,0,.88,11.48A17,17,0,0,0,690.06,560.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730,556.91a11.13,11.13,0,0,1-3.86.18c-1.57-.16-2.47-.67-2.71-1.55a49.58,49.58,0,0,1-1-5.88c-.34-2.77-.58-4.9-.7-6.38q-.81,3.35-2.34,7.81a29.27,29.27,0,0,1-2.47,5.85,1.87,1.87,0,0,1-1.14.79A8.92,8.92,0,0,1,713,558a9.55,9.55,0,0,1-2.93-.66,6.65,6.65,0,0,1-2.76-2.18,11,11,0,0,1-1.9-4q-2.14-8-1-26.81,0-.47.63-.66a8.94,8.94,0,0,1,4.13.2c1.75.41,2.72,1,2.91,1.67a2.2,2.2,0,0,1,0,.62q-1,16.61.43,23.21a76,76,0,0,0,3.91-13.16q2.08-9.15,3.26-17.46a.79.79,0,0,1,.67-.73,7.76,7.76,0,0,1,3.68.21c1.57.38,2.44.87,2.6,1.46a2.8,2.8,0,0,1,.08.65q.13,7.56,1.18,17.78a105.77,105.77,0,0,0,2.37,15.17c.09.34.22.73.39,1.19a9.66,9.66,0,0,1,.31.92,1.2,1.2,0,0,1,0,1A1.59,1.59,0,0,1,730,556.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.23,526.23a9.81,9.81,0,0,1-3.8.06c-1.56-.23-2.43-.67-2.6-1.33a25.08,25.08,0,0,1-.6-5.46,26.56,26.56,0,0,1,.2-5.18,1.26,1.26,0,0,1,1-1,9.38,9.38,0,0,1,3.5,0c1.54.22,2.4.66,2.57,1.3a2,2,0,0,1,0,.64,33.93,33.93,0,0,0,.51,10C737.19,525.73,736.91,526.05,736.23,526.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.24,544c.36,0,.62.3.78.92s-.34,1.28-1.46,2.25a8.48,8.48,0,0,1-3.27,1.87,1.91,1.91,0,0,1-1.86-.2,79.86,79.86,0,0,1-6.36-6.75,56.49,56.49,0,0,1-4.51-5.9A64.77,64.77,0,0,0,750,549.09c.15.57-.35,1-1.5,1.31a10.79,10.79,0,0,1-3.77.28c-1.36-.12-2.12-.46-2.27-1q-.59-2.2-.94-12t-.16-17.28c-1.67-1.19-2.62-2.19-2.84-3a.65.65,0,0,1,.21-.61,36.08,36.08,0,0,1,5.69-4.71A20.52,20.52,0,0,1,750.2,509a9.86,9.86,0,0,1,3.69-.37,9.16,9.16,0,0,1,3.47,1.25,10.61,10.61,0,0,1,2.9,2.12,6.68,6.68,0,0,1,1.4,2.75q.92,3.42-1.16,9.43a34.34,34.34,0,0,1-5,9.83A67.65,67.65,0,0,0,765.24,544Zm-10.56-30.27a16.2,16.2,0,0,0-6.18,3.65q-.3,6.33-.11,14.48,2.77-2.77,5-8.77T754.68,513.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.13,501.34c1.12-.31,2.28.16,3.48,1.39a8.11,8.11,0,0,1,2.16,3.16.56.56,0,0,1-.37.77,70.73,70.73,0,0,0-9.74,4.88c-.23,2-.39,4.71-.48,8.14a22.36,22.36,0,0,1,3.88-2.36c.59-.15,1.59.26,3,1.26s2.21,1.81,2.39,2.46c.09.36,0,.6-.28.7a26.3,26.3,0,0,0-4.7,2.73,47.39,47.39,0,0,0-4.34,3.4,75.77,75.77,0,0,0,.58,9,48.92,48.92,0,0,1,4.38-4.66,17.89,17.89,0,0,1,3-2.59c.74-.2,1.81.22,3.23,1.24s2.23,1.92,2.43,2.69c.09.33.06.54-.1.65a69.56,69.56,0,0,0-11.22,11.29,1.75,1.75,0,0,1-.8.57c-.87.23-2.23-.07-4.07-.9s-2.85-1.62-3-2.34a57.44,57.44,0,0,1-1.3-12c-.18-5.38-.14-10.65.12-15.78a11.55,11.55,0,0,1-2.83-1.3c-.92-.59-1.46-1.13-1.59-1.64a.63.63,0,0,1,.19-.67,55,55,0,0,1,7-4.84,68.92,68.92,0,0,1,8.46-4.7A.67.67,0,0,1,780.13,501.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.73,535.05a6.61,6.61,0,0,1-3.82-.5c-1.59-.58-2.46-1.15-2.61-1.72a1,1,0,0,1,.07-.49,1.74,1.74,0,0,0,0-.79,160.92,160.92,0,0,1-.88-36.21.89.89,0,0,1,.73-.83,9.46,9.46,0,0,1,4,.06c1.68.3,2.6.75,2.76,1.34a2.64,2.64,0,0,1,0,.73,147.23,147.23,0,0,0,0,30.14q3-2.32,7.24-5a36,36,0,0,1,5-2.92c.76-.2,1.84.26,3.23,1.39a6.68,6.68,0,0,1,2.37,2.74c.05.2,0,.34-.08.41a16,16,0,0,1-2.22,1.46,1,1,0,0,1-.7,0,70.1,70.1,0,0,0-7.13,4.39,66.36,66.36,0,0,0-6.79,5.13A3.14,3.14,0,0,1,814.73,535.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.11,524.29a11.32,11.32,0,0,1-6-.12,9,9,0,0,1-5.08-3.51,17.39,17.39,0,0,1-2.64-6,37.08,37.08,0,0,1-1.2-11.37,27.93,27.93,0,0,1,2.21-10.18q1.94-4.29,4.93-5.1a6.46,6.46,0,0,1,4.71.55,8.2,8.2,0,0,1,5.63,2,12.19,12.19,0,0,1,3,5.82,38.23,38.23,0,0,1,.92,12.62,37.83,37.83,0,0,1-2.12,11.14A6.5,6.5,0,0,1,845.11,524.29Zm-3.58-4.55q2-2.65,2.47-9.86a38.39,38.39,0,0,0-.94-12.69,14.34,14.34,0,0,0-1.53-3.81q-3,3-3.57,8.88a31.38,31.38,0,0,0,.87,11.49A17.14,17.14,0,0,0,841.53,519.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.49,519.93a11,11,0,0,1-5.11.1,13.63,13.63,0,0,1-4.53-1.72,23.31,23.31,0,0,1-3.14-2.31,4.86,4.86,0,0,1-1.41-1.72c-.22-.82.22-1.83,1.32-3a7.41,7.41,0,0,1,3.16-2.22,1.11,1.11,0,0,1,1.16.26,22.15,22.15,0,0,0,5,3.78q2.67,1.47,4.32,1,.12-1.7-1.94-4.55a50.37,50.37,0,0,0-4.64-5.51,73.1,73.1,0,0,1-5.08-5.85,16.59,16.59,0,0,1-3.08-5.36,10.78,10.78,0,0,1-.22-5,9.24,9.24,0,0,1,1.78-4,13.36,13.36,0,0,1,3-2.81,12.47,12.47,0,0,1,3.7-1.69,7.49,7.49,0,0,1,5.3.39A9.26,9.26,0,0,1,872,483a14.56,14.56,0,0,1,2,4.53c.43,1.6.52,2.6.27,3-.53.93-1.93,1.7-4.17,2.3-1.5.4-2.33.29-2.5-.33,0,0,0-.14-.07-.34s-.09-.45-.15-.75-.14-.6-.23-.92q-1.47-5.49-5.14-6.22a5.82,5.82,0,0,0-.73,5,16.06,16.06,0,0,0,2.92,5.24,57.26,57.26,0,0,0,4.8,5.52,64.12,64.12,0,0,1,4.77,5.38,14.77,14.77,0,0,1,2.84,5,5.33,5.33,0,0,1-.71,4.36,10.26,10.26,0,0,1-3.3,3.35A15.53,15.53,0,0,1,868.49,519.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.27,469.84c.82-.22,1.86.16,3.13,1.15a5.86,5.86,0,0,1,2.27,2.84c.2.74-.25,1.25-1.35,1.54a58.64,58.64,0,0,0-9,4,1.7,1.7,0,0,1,.79.88l0,.13q.15,8,.88,17.64a78.81,78.81,0,0,0,2.22,14.74c.14.53-.26.92-1.21,1.18a9.64,9.64,0,0,1-3.55.16,5.08,5.08,0,0,1-2.88-1,3,3,0,0,1-.57-1.26c-.22-.84-.19-1.4.12-1.65q-1.62-8.38-2-27.52-2.72,1.54-4,2.35c-.48.32-.74.48-.77.49-.68.18-1.71-.2-3.11-1.14a5.4,5.4,0,0,1-2.37-2.46.77.77,0,0,1,.39-.87q2.47-1.75,10.46-6.16T895.27,469.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M777.78,426.41l-2,.54,1.12,4.19-1.35.36-2.7-10.08,3.73-1c2.65-.71,3.74.58,4.13,2.06a2.77,2.77,0,0,1-1.53,3.36l3.76,3.68-1.52.41Zm-2.35-.59,2.23-.6c1.56-.42,1.86-1.35,1.59-2.36s-1-1.68-2.56-1.26l-2.23.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M791,426.14l.31,1.13L785,429l-2.7-10.08,6.25-1.67.3,1.13-4.9,1.32.86,3.21,4.66-1.25.3,1.13L785.07,424l.92,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M791.36,421.82c-.83-3.09.18-5.68,3.17-6.48a3.83,3.83,0,0,1,4.94,2.47l-1.34.51a2.69,2.69,0,0,0-3.36-1.81c-2,.53-2.65,2.48-2,4.92s2.18,3.86,4.24,3.31a2.85,2.85,0,0,0,2.07-3.19l1.36-.12a4,4,0,0,1-3.12,4.49C794.2,426.76,792.14,424.75,791.36,421.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M801.14,419.23c-.88-3.29.41-5.77,3.2-6.52s5.14.76,6,4.05-.4,5.77-3.19,6.52S802,422.46,801.14,419.23Zm7.8-2.09c-.69-2.58-2.28-3.83-4.29-3.29s-2.78,2.42-2.09,5,2.29,3.83,4.31,3.29S809.63,419.71,808.94,417.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M816,416.16l-2,.54,1.12,4.19-1.35.36-2.7-10.08,3.74-1c2.64-.71,3.73.58,4.13,2.06a2.79,2.79,0,0,1-1.54,3.36l3.76,3.69-1.52.4Zm-2.35-.59,2.23-.6c1.56-.42,1.86-1.35,1.59-2.36s-1-1.68-2.56-1.26l-2.23.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M820.5,408.64l3.31-.88c2.9-.78,5.33.74,6.13,3.74s-.52,5.56-3.46,6.35l-3.28.87Zm5.65,8.08c2.17-.59,2.94-2.68,2.36-4.84s-2.25-3.56-4.42-3l-1.93.52,2.09,7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M837.7,411.72l-4.12,1.1-.26,3.19-1.39.38,1.12-11.11,1.34-.36,6.52,9.06-1.39.37Zm-.7-1-2.46-3.56a5.32,5.32,0,0,1-.45-.7h0a7.05,7.05,0,0,1,0,.83l-.36,4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M849,408.84c.34,1.29,0,3-2.6,3.67l-3.8,1-2.7-10.09,3.5-.94c2.66-.71,3.75.6,4.07,1.79a2.28,2.28,0,0,1-1.1,2.64A2.38,2.38,0,0,1,849,408.84Zm-7.45-4.62.87,3.23,2.15-.57c1.74-.47,1.78-1.44,1.59-2.13s-.82-1.55-2.45-1.11Zm6.08,4.85c-.25-.93-1-1.53-2.38-1.16l-2.53.68.92,3.44,2.39-.64C847.61,411,847.88,410,847.64,409.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M849.25,400.94l1.34-.36,2.4,8.95,4.66-1.25.3,1.13L852,411Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M865.7,406.12l.3,1.14-6.35,1.7L857,398.88l6.25-1.68.3,1.14-4.89,1.31.86,3.21,4.65-1.25.31,1.14L859.77,404l.93,3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M767.23,400.62c-3.16-11.81-.94-18.23,7-20.37,6.65-1.78,11.08,1,13.35,8.37l-4,1.53c-1.68-5.33-4.49-7.46-8.49-6.39-5.48,1.47-6.14,6.28-3.62,15.66,2.58,9.62,5.6,13.3,11.09,11.83,3.81-1,5.26-4.35,4.23-9.66l4.18-.42c1.34,7.26-1.23,12-7.5,13.67C775.09,417.09,770.37,412.33,767.23,400.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M790.67,376.7l8.5-2.28c8.46-2.26,14.44,2,17.34,12.84,3,11.11-.27,18-8.64,20.2l-8.36,2.24Zm16.24,27.53c5.76-1.54,7.67-6.88,5.28-15.81s-6.57-12.24-12.33-10.69l-4.28,1.14,7.1,26.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M832.57,385.1l.94,3.53-11.61,3.12-.95-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M847.48,381.81l-5,1.34,3.76,14-4.05,1.08-8.84-33,9.39-2.51c7.25-1.95,10.73,1.36,12.2,6.84,1.13,4.23.22,8.11-3.45,10.39l10.69,12.93-4.56,1.22ZM841.61,380l5.07-1.36c4-1.08,4.9-4,3.87-7.86s-3.19-5.77-7.28-4.67l-5,1.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 899.23,
    y: 85.21,
    width: 8.32,
    height: 166.39,
    rx: 4.16,
    transform: "matrix(0.97, -0.26, 0.26, 0.97, -12.8, 239.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1000.82,
    y: 464.32,
    width: 8.32,
    height: 166.39,
    rx: 4.16,
    transform: "translate(-107.46 278.76) rotate(-15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M320.22,903.26,132.5,202.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1072.15 701.78 884.44 1.23 132.5 202.71 112.28 220.64 300 921.2 1051.93 719.72 1072.15 701.78 1072.15 701.78"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "134.38 209.71 185.75 195.94 369.71 882.49 318.34 896.26 320.22 903.26"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 284.6,
    y: 93.87,
    width: 693.84,
    height: 701.1,
    rx: 24.18,
    transform: "translate(-93.51 178.59) rotate(-15)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M882.15,39.38a24.17,24.17,0,0,0-29.61-17.09l-526.37,141L238,316.1,380.89,849.46a24.17,24.17,0,0,0,29.61,17.1l31-8.31L892.33,77.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "796.86 763.03 987.55 432.75 924.17 196.23 560.34 826.41 796.86 763.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "933.93 726.3 1024.28 569.82 997.05 468.22 832.34 753.53 933.93 726.3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.87b0a4a3c7c9d358fb27427d1439d75c.svg";
export { ForwardRef as ReactComponent };